import React from "react"
import { Col, Modal, ModalBody, Row } from "reactstrap"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"
import avatar from "assets/images/other/people.jpeg"
import { IoCloseSharp } from "react-icons/io5"
import { getRoleLabel, ROLE_TYPES } from "hooks/useRole"

function Profile({ show, onCloseClick, state, setState }) {
  const { profileDetails } = useSelector(state => ({
    profileDetails: state.Profile.profile,
  }))

  const branch = profileDetails?.branch || {}

  return (
    <div>
      <Modal
        isOpen={show}
        toggle={onCloseClick}
        centered={true}
        className="bg-orange"
      >
        <ModalBody className="p-4">
          <div className="d-flex align-items-center justify-content-end">
            <IoCloseSharp
              style={{ cursor: "pointer" }}
              className="text-danger font-size-18"
              onClick={onCloseClick}
            />
          </div>
          <div className="media">
            <div className="me-3">
              <img
                src={avatar}
                alt=""
                style={{ objectFit: "contain" }}
                className="avatar-sm rounded-circle img-thumbnail"
              />
            </div>
            <div className="media-body">
              <div className="media">
                <div className="media-body">
                  <div className="text-muted">
                    <h5 className="mb-1">
                      {profileDetails?.name} ({branch?.branch_name})
                    </h5>
                    {profileDetails?.role === ROLE_TYPES.MEMBER && (
                      <p
                        className="mb-0"
                        style={{ textTransform: "capitalize" }}
                      >
                        {profileDetails?.role} :{" "}
                        {getRoleLabel(profileDetails?.memberRole)}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <hr />

              <Row>
                {profileDetails?.phone && (
                  <Col xl={6}>
                    <div className="d-flex align-items-center">
                      <p className="text-muted text-truncate mb-2">
                        <i className="bx bx-phone text-secondary pe-2" />
                        {profileDetails?.phone}
                      </p>
                    </div>
                  </Col>
                )}
                {profileDetails?.email && (
                  <div className="col-8">
                    <div className="d-flex align-items-center">
                      <p className="text-muted text-truncate mb-2">
                        <i className="bx bx-mail-send text-primary pe-2" />
                        {profileDetails?.email}
                      </p>
                    </div>
                  </div>
                )}
                {branch?.branch_admin?.address && (
                  <div className="col-12">
                    <div className="d-flex align-items-center">
                      <p className="text-muted text-truncate mb-2">
                        {branch?.branch_admin?.address}
                      </p>
                    </div>
                  </div>
                )}
              </Row>

              <hr />

              <Row>
                <p>Branch Details</p>
                <div className="col-8">
                  {branch?.branch_name && (
                    <div className="d-flex align-items-center">
                      <p className="text-muted text-truncate mb-2">
                        <i className="bx bx-store-alt text-primary pe-2" />
                        {branch?.branch_name}
                      </p>
                    </div>
                  )}
                  {branch?.description && (
                    <div className="d-flex align-items-center">
                      <p className="text-muted  mb-2">
                        <i className="bx bxs-detail text-primary pe-2" />
                        {branch?.description}
                      </p>
                    </div>
                  )}
                  {branch?.location && (
                    <div className="d-flex align-items-center">
                      <p className="text-muted text-truncate mb-2">
                        <i className="bx bx-map text-primary pe-2" />
                        {branch?.location}
                      </p>
                    </div>
                  )}
                  {branch?.personal_number && (
                    <div className="d-flex align-items-center">
                      <p className="text-muted text-truncate mb-2">
                        <i className="bx bx-phone text-secondary pe-2" />
                        {branch?.personal_number}
                      </p>
                    </div>
                  )}
                </div>
                {branch?.image && (
                  <div className="col-4">
                    <div className="d-flex align-items-center">
                      <img
                        src={branch?.image?.[0]?.url}
                        className="avatar-lg rounded-circle img-thumbnail"
                      />
                    </div>
                  </div>
                )}
              </Row>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default Profile

Profile.propTypes = {
  onCloseClick: PropTypes.any,
  show: PropTypes.any,
  state: PropTypes.any,
  setState: PropTypes.any,
}
